import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=2c0d6eac&lang=pug&"
import script from "./Tutorials.vue?vue&type=script&lang=ts&"
export * from "./Tutorials.vue?vue&type=script&lang=ts&"
import style0 from "./Tutorials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports